// extracted by mini-css-extract-plugin
module.exports = {"container":"Section8_container__m1qne","content":"Section8_content__XVtb0","testimonial":"Section8_testimonial__bGWau","source":"Section8_source__gC73O"};